import { useMediaQuery } from "./use-media-query";

// Tailwind breakpoints from config
const breakpoints = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1392px",
} as const;

type Breakpoint = keyof typeof breakpoints;

/**
 * Hook to check if current viewport matches a Tailwind breakpoint
 * @param breakpoint - Tailwind breakpoint key (sm, md, lg, xl, 2xl)
 * @returns true if viewport width is >= breakpoint
 */
export function useBreakpoint(breakpoint: Breakpoint): boolean {
  return useMediaQuery(`(min-width: ${breakpoints[breakpoint]})`);
}

/**
 * Convenience hooks for common responsive patterns
 */
export function useIsMobile(): boolean {
  return !useBreakpoint("md"); // < 768px
}

export function useIsTablet(): boolean {
  const isMd = useBreakpoint("md"); // >= 768px
  const isLg = useBreakpoint("lg"); // >= 1024px
  return isMd && !isLg; // 768px - 1023px
}

export function useIsDesktop(): boolean {
  return useBreakpoint("lg"); // >= 1024px
}

